import { type FC } from "react";

import { type Playbook } from "../../../../graphql.js";
import { PLAYBOOK_CLASS } from "../../../../settings/settings.js";
import { ProtectedResourceLogo } from "../../ProtectedResourceLogo.js";
import { type IAgGridCellProps } from "../cell-base-interfaces.js";
import { TableCell } from "./core/TableCell.js";
import TextCell from "./core/TextCell.js";

const PlaybookAdminCell: FC<IAgGridCellProps> = (props) => {
  if (!props.value) {
    return null;
  }
  const playbook: Playbook = props.data.playbook;
  const editable = !playbook.standard && playbook.enabled && playbook.type.class !== PLAYBOOK_CLASS.BLAST;

  const onPlaybookClicked =
    typeof (props as any).handlePlaybookClicked === "function" && (props as any).handlePlaybookClicked;

  return (
    <TableCell
      triggerButtonProps={
        onPlaybookClicked && editable
          ? {
              icon: "edit",
              onPress: () => onPlaybookClicked(playbook),
              label: "Edit Playbook",
              e2eActionId: "edit-playbook",
            }
          : playbook.standard
            ? { icon: <ProtectedResourceLogo />, onPress: undefined, label: undefined }
            : undefined
      }
    >
      <TextCell {...props} tooltip={props.value} />
    </TableCell>
  );
};

export { PlaybookAdminCell };
export default PlaybookAdminCell;
